import useFieldApi, { UseFieldApiConfig } from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import clsx from 'clsx';
import moment from 'moment';
import React, { useRef, FC } from 'react';
import { useTranslation } from 'react-i18next';
import MaskedInput from 'react-text-mask';
import { useOverflow } from '../../hooks';
import { isRequiredValidation } from '../../utils';
import { Tooltip } from '../Tooltip';
import { FieldWrapper } from './FieldWrapper';

interface DateInputProps {
  value?: string;
  onChange: (date: any) => any;
  label?: string;
  wrapperClasses?: string;
  toolTip?: string;
  isError?: boolean;
  error?: string;
  isRequired?: boolean;
  errorClassName?: string;
  fieldLabelClasses?: string;
  name: string;
}

const DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
const FORMAT: string = 'MM/DD/YYYY';

/* istanbul ignore next */ /* this code is not used or will be deleted in other branches */
export function DateInputDdf(props: UseFieldApiConfig) {
  const {
    input,
    meta: { error, modified }
  } = useFieldApi(props);
  const isError = modified && error && typeof error === 'string';
  const isRequired = isRequiredValidation(props.validate);
  const { t: translate } = useTranslation('form');

  const pipe = (value: any) => {
    if (moment(value).isValid()) {
      input.onChange(value);
    }
  };

  let modifiedValue = input.value;
  if (!modified) {
    modifiedValue = modifiedValue && moment(modifiedValue).format(FORMAT);
  }

  return (
    <DateInput
      label={translate(props.label)}
      wrapperClasses={props.wrapperClasses}
      toolTip={props.toolTip}
      isError={isError}
      error={error}
      isRequired={isRequired}
      value={modifiedValue || null}
      onChange={pipe}
      name={props.name}
    />
  );
}

export const DateInput: FC<DateInputProps> = ({
  label,
  wrapperClasses,
  toolTip,
  isError,
  error,
  isRequired,
  value,
  onChange,
  errorClassName,
  fieldLabelClasses,
  name,
  ...rest
}: DateInputProps) => {
  const inputRef = useRef<HTMLParagraphElement>(null);
  const { overflowActive } = useOverflow(inputRef?.current?.firstChild);

  return (
    <FieldWrapper
      className={wrapperClasses}
      toolTip={toolTip}
      name={name}
      label={label}
      isError={isError}
      error={error}
      errorClassName={errorClassName}
      fieldLabelClasses={fieldLabelClasses}
      {...rest}
    >
      <p ref={inputRef} data-tip={value} data-for={name}>
        <MaskedInput
          {...rest}
          className={clsx('truncate form-field react-datepicker_custom', isError && 'form-field-error')}
          mask={DATE_MASK}
          required={isRequired}
          id={name}
          data-testid='date-input'
          keepCharPositions
          guide
          value={value}
          onChange={onChange}
        />
      </p>
      {overflowActive && <Tooltip name={name} />}
    </FieldWrapper>
  );
};
